import HomePageSectionHeader from "components/homePageSectionHeader/homePageSectionHeader";
import type { TalkData } from "content-ui/talks/types";
import { upcomingTalks } from "content-ui/talks/utils";
import { useHomepageData, useHomepageDatoProps } from "lib/store/homepage";
import { useMixpanelTracking } from "lib/hooks/useMixpanelTracking";
import { EventCard } from "components/eventCard/eventCard";
import { TalkBody } from "components/eventCard/talkElements";
import TalkRegistration from "content-ui/talks/components/registration/talkRegistration/talkRegistration";
import { AddToCalendar } from "components/addToCalendar/addToCalendar";

export const TalksSectionContent = () => {
  const { talks } = useHomepageData();

  const data = useHomepageDatoProps();
  const { track } = useMixpanelTracking();

  return (
    <div className="w-full">
      <HomePageSectionHeader
        title={data.talksSectionHeader?.title}
        buttonText={data.talksSectionHeader?.cta?.text}
        buttonUrl={data.talksSectionHeader?.cta?.url}
        onButtonClick={async () => {
          await track("Homepage link click", {
            "Click link": data.talksSectionHeader?.cta?.url,
            "Click text": data.talksSectionHeader?.cta?.text,
            Component: "Talks",
          });
        }}
        className="mb-4"
      />

      {talks &&
        upcomingTalks(talks)
          .slice(0, 1)
          .map((talk: TalkData) => {
            return (
              <EventCard
                key={talk.id}
                cardLink={`/talks/${talk.slug}`}
                image={talk.image}
                sponsorImage={talk?.sponsorLogo}
                heading={talk.marketLabel}
                title={talk.title}
                body={<TalkBody talk={talk} />}
                registration={<TalkRegistration talk={talk} allTalks={talks} />}
                eventDateTime={new Date(talk.dateTime)}
                variant="talk"
                excerpt={talk.excerpt}
                sponsorDetails={talk.sponsorDetails}
                calendar={
                  <AddToCalendar
                    event={talk}
                    classNames="text-secondary-cta [&>span]:ml-md space-x-2xl"
                    type="talk"
                  />
                }
              />
            );
          })}
    </div>
  );
};

export const TalksSection = () => {
  const { talks } = useHomepageData();
  if (!talks || upcomingTalks(talks).length === 0) {
    return null; // Don't render the section if there are no upcoming talks
  }
  return (
    <section className="w-full pb-16">
      <TalksSectionContent />
    </section>
  );
};
